const INFLATION = 1.37;                          // Current inflation conversion as of 5/20/2025

export const RG_COST_RATE = 3 * INFLATION;       // $3 per square foot (2015 report)
export const GR_COST_RATE = 9.60 * INFLATION;    // $9.60 per square foot (2015 report)
export const PLANTER_COST_RATE = 30 * INFLATION; // $30 per square foot (2015 report)
export const RB_COST_RATE = 0.50 * INFLATION;    // $0.50 per gallon (2015 report)
